import type { JSX } from 'react';

import { PageBody } from '../components/PageBody';
import { PageHeading } from '../components/PageHeading';
import { PageMeta } from '../components/PageMeta';

import { useTrackPageView } from './hooks/useTrackPageView';

export function Layout(): JSX.Element {
	useTrackPageView();

	return (
		<>
			<PageMeta />
			<div className="container mb-6 space-y-8 md:mb-16 md:space-y-16">
				<PageHeading />
				<PageBody />
			</div>
		</>
	);
}
